import React from 'react';
import { VelocityVision } from '../../components/velocityVision/VelocityVision/VelocityVision';
import styles from './velocityVisionPage.module.scss';

const VelocityVisionPage: React.FC = () => {
	return (
		<div className={styles.velocityVisionPageContainer}>
			<VelocityVision />
		</div>
	);
};

export { VelocityVisionPage };
